import React from 'preact/compat';
import { useState, useEffect } from 'preact/hooks';

import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import ErrorIcon from '@mui/icons-material/Error';

import colors from '../colors';
import LauncherPopup from './LauncherPopup';

import { useParamsError } from '../../state/parameterStore';
import { useGenerationError } from '../../state/generationStore';

const LauncherErrorPopup = ({appName}) => {
    const [open, setOpen] = useState(false);
    const [lastError, setLastError] = useState();
    const [errorMessage, setErrorMessage] = useState("Unexpected error occurred. " +
        "Verify your internet connection, reload the page and contact support if the error persists");

    const launcherParamsError = useParamsError();

    const generationErrorGDK = useGenerationError();

    const error = launcherParamsError || generationErrorGDK;

    const onClose = () => {
        setLastError(error);
        setOpen(false);
    }

    useEffect(() => {
        if (error && error !== lastError) {
            setErrorMessage(error?.message || error.toString());
            setOpen(true);
        }
    }, [setErrorMessage, error, lastError]);

    return (
        <LauncherPopup title="Error" open={open} onClose={onClose} Icon={ErrorIcon} iconColor={colors.option}>
            <Typography
                sx={{
                    color: colors.primaryText,
                    fontSize: '22px'
                }}
            >
                {errorMessage}
            </Typography>
            <Button
                onClick={onClose}
                sx={{
                    backgroundColor: colors.action,
                    height: '40px',
                    paddingLeft: '40px',
                    paddingRight: '40px',
                    color: colors.primaryText,
                    fontSize: '18px',
                    fontWeight: 600,
                    marginLeft: 'auto',
                    display: 'block',
                    '&:hover': {
                        backgroundColor: colors.actionHover
                    }
                }}
            >
                OK
            </Button>
        </LauncherPopup>
    );
};

export default LauncherErrorPopup;
